import { ShieldCheck } from "lucide-react";
import { Carte, COL, Indisponible, Ligne, Vide, dateFr, dateHeureFr, isErreur } from "./shared";

const STATUTS = [["brouillon", "Brouillons"], ["verrouille", "Verrouillés"], ["exporte", "Exportés"], ["corrige", "Corrigés"],
  ["valide", "Validés"]];
const ZNT = {
  ok: ["Respectée", COL.green],
  a_verifier: ["À vérifier : traitement à moins de 50 m d'un cours d'eau", COL.amber],
  non_evaluable: ["Non évaluable (distance au cours d'eau inconnue)", "#6B7280"],
};

export default function ConformiteCard({ data }) {
  return (
    <Carte titre="Conformité phyto" numero="6" icon={ShieldCheck} testId="fiche-conformite">
      {isErreur(data) ? <Indisponible /> : (
        <>
          <div className="flex flex-wrap gap-1.5 pb-2">
            {STATUTS.filter(([k]) => data.statuts[k] || k !== "valide").map(([k, l]) => (
              <span key={k} className="text-xs px-2.5 py-1 rounded-full font-medium"
                style={k === "brouillon" && data.statuts[k]
                  ? { background: COL.amberSoft, color: COL.amber } : { background: "#F1F0EC", color: COL.muted }}>
                {l} : {data.statuts[k]}
              </span>
            ))}
          </div>
          <Ligne label="ZNT">
            <span style={{ color: ZNT[data.znt.etat][1] }}>{ZNT[data.znt.etat][0]}</span>
          </Ligne>
          <Ligne label="Dernier export">
            {data.dernier_export ? (
              <span className="flex flex-col items-end">
                <span>{dateFr(data.dernier_export.date)} · {data.dernier_export.format}</span>
                <span className="font-mono text-[11px] text-gray-500">SHA-256 {data.dernier_export.sha256?.slice(0, 12)}…</span>
              </span>
            ) : <span className="text-gray-500">Aucun</span>}
          </Ligne>
          <Ligne label="Lien de contrôle">
            {data.lien_controle ? `Actif jusqu'au ${dateHeureFr(data.lien_controle.expire_le)}`
              : <span className="text-gray-500">Aucun lien actif</span>}
          </Ligne>
          <div className="pt-2">
            <div className="text-sm font-semibold mb-1" style={{ color: COL.text }}>Délais avant récolte en cours</div>
            {data.dar_en_cours.length ? data.dar_en_cours.map((d, i) => (
              <div key={i} className="flex justify-between gap-2 py-1 text-sm">
                <span>{d.produit}{d.ilot_nom ? ` · ${d.ilot_nom}` : ""}</span>
                <span className="font-semibold shrink-0" style={{ color: COL.amber }}>Récolte dès le {dateFr(d.recolte_possible_le)}</span>
              </div>
            )) : <Vide>Aucun : récolte possible.</Vide>}
          </div>
          {data.delai_rentree_en_cours.length > 0 && (
            <div className="pt-2">
              <div className="text-sm font-semibold mb-1" style={{ color: COL.text }}>Délai de rentrée en cours</div>
              {data.delai_rentree_en_cours.map((d, i) => (
                <div key={i} className="flex justify-between gap-2 py-1 text-sm">
                  <span>{d.produit}{d.ilot_nom ? ` · ${d.ilot_nom}` : ""}</span>
                  <span className="font-semibold shrink-0" style={{ color: COL.amber }}>Pas d'entrée avant le {dateHeureFr(d.jusqu_au)}</span>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </Carte>
  );
}
